import React from 'react';
import SearchBodySearchResultResultList from './SearchBodySearchResultResultList';
//import ResultTList from './ResultTList';
//import ResultTList from './ResultTList';
//import { Tab, Tabs/*, TabList, TabPanel*/ } from 'react-tabs';
//import '../../css/react-tabs2.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

// import '../../css/bootstrap.min.css';
// import '../../css/bootstrap-rtl.min.css';
// import '../../css/bootstrap-grid.min.css';
// //import '../../css/jquery-ui.min.css';
// import '../../css/keyboard.min.css';
// import '../../font/dana/fontiran.css';
// import '../../font/dana/style.css';
// import '../../css/menu.css';
// import '../../css/style.css';

class SearchBodySearchResult extends React.Component {
    //state = { statments : [] }
    state = { word : '' }

    constructor(props) {
        super(props);
        //this.state = { statments: this.props.statments };
        this.state = { results: this.props.results };
        this.state = { t_results: this.props.t_results };
        this.state = { word: this.props.word };
    }
    
    render() {
        return (
            <div className="container-fluid" id="words_search_results">
                <div className="container">
                    <div className="alert" role="alert">
                        {this.props.pageData.length!==0 && this.props.pageData[0].F29904!== undefined?this.props.pageData[0].F29904:29904/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                    </div>
                    <Tabs
                        activeKey={this.state.key}
                        onSelect={this.handleSelect}
                        id="form_tabs_2"
                    >
                        <Tab eventKey={21} title={this.props.pageData.length!==0 && this.props.pageData[0].F20230!== undefined?this.props.pageData[0].F20230:20230/*"فهرست واژگان"*/}>
                            <div className="word_section">
                                <SearchBodySearchResultResultList
                                            results={this.props.results}
                                            pageData={this.props.pageData}
                                            searchtabIndex={this.props.searchtabIndex}
                                            ResulttabIndex={0}
                                            SelectedBookGroup={this.props.SelectedBookGroup}
                                />
                            </div>
                        </Tab>
                        <Tab eventKey={22} title={this.props.pageData.length!==0 && this.props.pageData[0].F20231!== undefined?this.props.pageData[0].F20231:20231/*"تنوع و بسامد واژه"*/}>
                            <div className="word_section">
                                <SearchBodySearchResultResultList
                                            results={this.props.t_results}
                                            pageData={this.props.pageData}
                                            searchtabIndex={this.props.searchtabIndex}
                                            ResulttabIndex={1}
                                            SelectedBookGroup={this.props.SelectedBookGroup}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                    </div>
                </div>

//             <div style={{width:'100%'}}>
//                 {
//                     //console.log("statmentsInSearchResult1", this.props.statments)
//                 }
//                 <Tabs   className="result-tabs"
//                         selectedTabPanelClassName="result_tab-panel--selected" 
//                         selectedTabClassName="result_tab--selected"
//                         disabledTabClassName="result_tab--disabled">
//                     <TabList className ="result-tab-list">
//                         <Tab className ="result_tab">فهرست واژگان</Tab>
//                         {/*<Tab className ="result_tab">متون</Tab>*/}
//                         <Tab className ="result_tab">تنوع و بسامد واژه</Tab>
//                     </TabList>

//                     <TabPanel className ="result_tab-panel">
//                         <ResultList results={this.props.results}/>
//                     </TabPanel>
//                     {/*
//                     <TabPanel className ="result_tab-panel">
//                         <StatmentList statments={this.props.statments} word={this.props.word} />
//                     </TabPanel>
//                     */}
//                     <TabPanel className ="result_tab-panel">
//                         <ResultTList results={this.props.t_results}/>
//                     </TabPanel>
//                 </Tabs>
//             </div>
         )
     }
 }

export default SearchBodySearchResult;